module.exports = __webpack_public_path__ + "img/pr-12.e15e551c.png";